import { useQuery, useQueryClient } from "@tanstack/react-query";
import { CourseApi, coursesApi } from "api";
import { QUERIES_KEYS } from "queries";

export const useCourseQuery = (courseId?: string | number) => {
  const queryClient = useQueryClient();
  const { isLoading, data } = useQuery({
    queryKey: QUERIES_KEYS.COURSE_BY_ID(Number(courseId)),
    queryFn: () => coursesApi.fetchById(Number(courseId)),
    enabled: !!courseId,
  });
  const invalidate = () => {
    queryClient.invalidateQueries({
      queryKey: QUERIES_KEYS.COURSE_BY_ID(Number(courseId)),
    });
  };

  return { isLoading, course: data?.data ?? ({} as CourseApi), invalidate };
};
